import { render, staticRenderFns } from "./MeditationStreak.vue?vue&type=template&id=0849253c&scoped=true"
import script from "./MeditationStreak.vue?vue&type=script&lang=js"
export * from "./MeditationStreak.vue?vue&type=script&lang=js"
import style0 from "./MeditationStreak.vue?vue&type=style&index=0&id=0849253c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0849253c",
  null
  
)

export default component.exports